import { MailCodeOfferStatus } from '../enums/MailCodeOfferStatus';

export const mailCodeOfferStatusRoutes: Record<MailCodeOfferStatus, string> = {
  [MailCodeOfferStatus.COMPLETE]: '/mail/offer',
  [MailCodeOfferStatus.NO_MAIL_CODE]: '/mail',
  [MailCodeOfferStatus.NO_OFFER]: '/mail/activation',
  [MailCodeOfferStatus.PARTIAL]: '/sign-up',
};
